// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"IY-z","sponsoredTooltipWrapper":"JY-z","sponsoredTooltip":"KY-z","newCard":"LY-z"};